/* src/modules/profile/actions.js */

import {
  changePasswordTypes,
  modifyUserTypes,
  updateAdminNotificationPreferenceTypes,
} from './action_types';

import {
  CHANGE_PASSWORD_MUTATION,
  MODIFY_USER_MUTATION,
  UPDATE_ADMIN_NOTIF_PREF_MUTATION,
} from './api';
import { makeMutation } from '../../config/client';

export const changePassword = variables => makeMutation({ variables })(
  changePasswordTypes,
  CHANGE_PASSWORD_MUTATION
);

export const modifyUser = variables => makeMutation({ variables })(
  modifyUserTypes,
  MODIFY_USER_MUTATION
);

export const updateNotificationPreference = variables => makeMutation({ variables })(
  updateAdminNotificationPreferenceTypes,
  UPDATE_ADMIN_NOTIF_PREF_MUTATION
);



// WEBPACK FOOTER //
// ./src/modules/profile/actions.js